import { NotificationStorageService, StoredNotification } from './services/notification-storage.service';
import {
  APP_INITIALIZER,
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { AlertController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { AuthenticationService } from './services/authentication.service';
import { GlobalDataService } from './services/global-data.service';
import { AlertService } from './services/alert.service';
import { App } from '@capacitor/app';
import { register } from 'swiper/element/bundle';
import { BehaviorSubject, Observable } from 'rxjs';
import { VaultService } from './services/vault.service';
import { IsRoot } from '@capgo/capacitor-is-root';
import {
  IonApp,
  IonSplitPane,
  IonRouterOutlet,
  AlertButton,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  notifications,
  close,
  phonePortraitOutline,
  card,
  document as doc,
  cash,
  listCircle,
  cloudUpload,
  folder,
  arrowForward,
  contrastSharp,
  chatbubble,
  checkmarkCircle,
  locationSharp,
  call,
  mail,
  home,
  ellipsisHorizontal,
  person,
  timer,
  timeOutline,
  timerOutline,
  mailOutline,
  list,
  closeOutline,
  chevronDownOutline,
  chevronUpOutline,
  menu,
  flag,
  add,
  logoAndroid,
  logoApple,
  time,
  calendar,
  trash,
  contrast,
  flash,
  cropOutline,
  refreshOutline,
  contract,
  camera,
  cashOutline,
  cameraOutline,
  open,
  information,
  informationOutline,
  informationCircle,
  chevronForwardOutline,
  chevronForwardCircle,
  mailOpen,
  chevronBack,
  eyeOffOutline,
  eyeOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  heartOutline,
  heartSharp,
  archiveOutline,
  archiveSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
  bookmarkOutline,
  bookmarkSharp,
  reorderTwoOutline,
  notificationsCircleOutline,
  print,
  cashSharp,
  informationCircleOutline,
  help,
  lockClosed,
  desktop,
  arrowDownCircle,
  ellipse,
  alertCircle,
} from 'ionicons/icons';

import { USER_OBJECT } from './services/vault-service.constants';
import { Capacitor } from '@capacitor/core';
import { ClearCacheService } from './services/clear-cache.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from './services/http-interceptor';
import { RatingService } from './services/rating.service';
import {
  ActionPerformed as PushActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import {
  ScheduleOptions,
  LocalNotifications,
  ActionPerformed,
  LocalNotificationSchema,
} from '@capacitor/local-notifications';
import { APPCONSTANTS } from './services/app-service.constants';
import { Preferences } from '@capacitor/preferences';
import { SplashScreen } from '@capacitor/splash-screen';


export function clearIndexHtmlCache(cacheService: ClearCacheService) {
  return () => {
    cacheService.clearCacheForFile('index.html');
  };
}

register();

// StoredNotification moved

// Enhanced Notification Service
// NotificationStorageService moved

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonApp,
    IonSplitPane,
    IonRouterOutlet,
  ],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private globalDataVar: any;
  toggleOperator = 'add';
  userInactive: Subject<any> = new Subject();
  timeoutId: any;
  public appPages = [];
  private unsubscriber: Subject<void> = new Subject<void>();
  private pageTitleObserver?: MutationObserver;
  private readonly singleLineTitleReference = 'Request An Appointment';
  private pageTitleMeasureCanvas?: HTMLCanvasElement;

  // Enhanced notification management
  private notificationsSubject = new BehaviorSubject<StoredNotification[]>([]);
  public notifications$: Observable<StoredNotification[]> =
    this.notificationsSubject.asObservable();

  // Track pending notifications for Android
  private pendingAndroidNotifications: Map<number, StoredNotification> =
    new Map();

  constructor(
    private router: Router,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private clearCache: ClearCacheService,
    private platform: Platform,
    private vaultService: VaultService,
    public globalData: GlobalDataService,
    private ratingService: RatingService,
    private notificationStorage: NotificationStorageService
  ) {
    // window.location.href = 'gadcss://dashboard?status=success';
    App.addListener('appUrlOpen', event => {
      const url = new URL(event.url);
      const status = url.searchParams.get('status');

      if (url.pathname === '/dashboard' && status === 'successpayment') {
        this.ratingService.requestReview(() => {
          return;
        });
      }
    });
    addIcons({
      notifications,
      information,
      informationOutline,
      informationCircle,
      close,
      card,
      doc,
      cash,
      listCircle,
      cloudUpload,
      folder,
      arrowForward,
      contrastSharp,
      chatbubble,
      checkmarkCircle,
      locationSharp,
      cashOutline,
      cashSharp,
      time,
      help,
      informationCircleOutline,
      timeOutline,
      timerOutline,
      timer,
      call,
      arrowDownCircle,
      lockClosed,
      desktop,
      mail,
      mailOutline,
      phonePortraitOutline,
      closeOutline,
      chevronUpOutline,
      chevronDownOutline,
      list,
      logoAndroid,
      menu,
      flag,
      print,
      logoApple,
      add,
      contrast,
      trash,
      calendar,
      person,
      ellipsisHorizontal,
      reorderTwoOutline,
      home,
      notificationsCircleOutline,
      cropOutline,
      flash,
      refreshOutline,
      contract,
      camera,
      cameraOutline,
      open,
      chevronForwardOutline,
      chevronForwardCircle,
      mailOpen,
      ellipse,
      eyeOffOutline,
      eyeOutline,
      chevronBack,
      mailSharp,
      paperPlaneOutline,
      paperPlaneSharp,
      heartOutline,
      heartSharp,
      archiveOutline,
      archiveSharp,
      trashOutline,
      trashSharp,
      warningOutline,
      warningSharp,
      bookmarkOutline,
      bookmarkSharp,
      alertCircle,
      'hand-shake': 'assets/icon/handshake-solid.svg',
      'layer-group': 'assets/icon/layer-group-solid.svg',
      'bell-solid': 'assets/icon/bell-solid.svg',
      'bell-orange': 'assets/icon/bell-orange.svg',
      'money-solid': 'assets/icon/money-solid.svg',
      'clock-full': 'assets/icon/clock-full.svg',
      'upload-solid': 'assets/icon/upload-solid.svg',
      'id-card-solid': 'assets/icon/id-card-solid.svg',
      'file-circle-question-solid':
        'assets/icon/file-circle-question-solid.svg',
      'rectangle-list-solid': 'assets/icon/rectangle-list-solid.svg',
      'list-check-solid': 'assets/icon/list-check-solid.svg',
      'circle-question-solid': 'assets/icon/circle-question-solid.svg',
      'list-check': 'assets/icon/list-check-solid.svg',
    });

    this.initializeApp();
    this.globalDataVar = globalData;

    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(async _ => {
        if (
          this.globalData.agreementPageVisitedCount > 1 ||
          this.globalData.homePageVisitedCount > 1
        ) {
          window.history.forward();
        }
      });
    this.addAllIcons();
  }

  async ngOnInit() {
    await this.vaultService.init();

    // Load stored notifications on app start
    await this.loadStoredNotifications();

    if (Capacitor.getPlatform() !== APPCONSTANTS.WEB) {
      try {
        const { result } = await IsRoot.isRooted();
        if (result) {
          await App.exitApp();
        }
      } catch {
        await App.exitApp();
      }
    }

    await this.processPushNotifications();
    await this.setupLocalNotifications();
  }

  ngAfterViewInit() {
    this.updatePageHeaderTitleLengthClasses();
    this.pageTitleObserver = new MutationObserver(() => {
      this.updatePageHeaderTitleLengthClasses();
    });
    this.pageTitleObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ngOnDestroy() {
    this.pageTitleObserver?.disconnect();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  onViewportChanged() {
    this.updatePageHeaderTitleLengthClasses();
  }

  private updatePageHeaderTitleLengthClasses() {
    requestAnimationFrame(() => {
      const titleElements = document.querySelectorAll<HTMLElement>(
        '.page-header-toolbar .custom-page-title, .page-header-toolbar ion-title.page-header-title'
      );
      const shouldAllowTitleWrap =
        window.matchMedia('(orientation: portrait)').matches &&
        window.matchMedia('(max-width: 768px)').matches;

      titleElements.forEach(titleElement => {
        const titleText = (titleElement.textContent || '')
          .replace(/\s+/g, ' ')
          .trim();
        const titleFont = this.getPageHeaderTitleFont(titleElement);
        const referenceWidth = this.measurePageHeaderTitleText(
          this.singleLineTitleReference,
          titleFont
        );
        const titleWidth = this.measurePageHeaderTitleText(
          titleText,
          titleFont
        );

        titleElement.classList.toggle(
          'long-page-title',
          shouldAllowTitleWrap && titleWidth > referenceWidth
        );
      });
    });
  }

  private getPageHeaderTitleFont(titleElement: HTMLElement): string {
    const computedStyle = getComputedStyle(titleElement);
    return [
      computedStyle.fontStyle,
      computedStyle.fontVariant,
      computedStyle.fontWeight,
      computedStyle.fontSize,
      computedStyle.fontFamily,
    ].join(' ');
  }

  private measurePageHeaderTitleText(text: string, font: string): number {
    this.pageTitleMeasureCanvas ??= document.createElement('canvas');
    const context = this.pageTitleMeasureCanvas.getContext('2d');
    if (!context) {
      return text.length;
    }

    context.font = font;
    return context.measureText(text).width;
  }

  private async loadStoredNotifications(): Promise<void> {
    try {
      const storedNotifications =
        await this.notificationStorage.loadNotifications();
      this.notificationsSubject.next(storedNotifications);
    } catch (error) {
    }
  }

  private async setupLocalNotifications(): Promise<void> {
    try {
      // Request permissions for local notifications
      const permissions = await LocalNotifications.requestPermissions();


      // Listen for local notification actions
      LocalNotifications.addListener(
        'localNotificationActionPerformed',
        async (action: ActionPerformed) => {
          await this.handleNotificationAction(action);
        }
      );

      // Listen for local notification received (when app is in foreground)
      LocalNotifications.addListener(
        'localNotificationReceived',
        (notification: LocalNotificationSchema) => {
        }
      );
    } catch (error) {
    }
  }

  private async handleNotificationAction(
    action: ActionPerformed
  ): Promise<void> {
    const notificationId = action.notification.id;

    // Remove from pending notifications
    if (this.pendingAndroidNotifications.has(notificationId)) {
      this.pendingAndroidNotifications.delete(notificationId);
    }

    // Handle specific actions
    if (
      action.actionId === 'OPEN_LINK' &&
      action.notification.extra?.outboundUrl
    ) {
      const outboundUrl = action.notification.extra.outboundUrl;
      if (outboundUrl) {
        await Browser.open({ url: outboundUrl });
      }
    }

    // Mark notification as read if it exists
    await this.markNotificationAsRead(notificationId);
  }

  private initializeApp() {
    this.platform.ready().then(() => {
      this.platform.backButton.subscribeWithPriority(0, () => {
        App.minimizeApp();
      });

      window.addEventListener('keyboardDidShow', e => {
        const elementFocused: any = document.querySelector(':focus');
        if (elementFocused) {
          elementFocused.blur();
          elementFocused.focus();
        }
      });
    });

    this.translate.setDefaultLang('en');
    document.body.setAttribute('data-theme', 'light');
    document.body.classList.toggle('dark', false);

    setTimeout(() => SplashScreen.hide(), 500);
  }

  goTo(item: any) {
    if (item.sub === null) {
      if (item.external === false || item.external === undefined) {
        this.router.navigate([item.url]);
      } else {
        Browser.open({ url: item.url });
      }
    }
  }

  @HostListener('touchstart')
  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  checkUserActivity() {
    if (!this.globalData.isLogout) {
      this.restartIdleLogoutTimer();
      this.checkTimeOut();
    }
  }

  private async checkTimeOut() {
    let userObject: any = await this.vaultService.getKeyValue(USER_OBJECT);
    if (userObject != null) {
      if (userObject.authToken && this.globalData.isLogout == false) {
        if (
          (await this.authenticationService.isAccessTokenActive()) === false
        ) {
          this.authenticationService.clearUserObject();
          await this.authenticationService.refreshToken().then(
            async data => {
              if (
                (await this.authenticationService.isAccessTokenActive()) ===
                false
              ) {
                this.logoutUser();
              }
            },
            async error => {
              this.logoutUser();
            }
          );
        }
      }
    }
  }

  private idleLogoutTimer: any;
  private restartIdleLogoutTimer() {
    clearTimeout(this.idleLogoutTimer);
    this.idleLogoutTimer = setTimeout(async () => {
      let message = `Your session is about to expire. Click Continue to keep session active`;
      await this.alertService.presentAlert('Alert', message);
    }, 900000); // 15 minutes
  }

  private async logoutUser() {
    this.globalData.isLogout = true;
    this.authenticationService.logout();
    let alert: any = await this.alertCtrl.create({
      header: 'Alert',
      message: 'Your Session Timed Out!',
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Ok',
          role: 'Update',
          cssClass: 'alert-button-cancel',
          handler: async () => {
            alert?.dismiss();
            alert = null;
            await this.reload();
          },
        },
      ],
    });
    await alert.present();
    if (alert) {
      setTimeout(async () => {
        alert?.dismiss();
        await this.reload();
      }, 1000);
    }
  }

  private async reload() {
    await this.vaultService.clearVault();
    await this.authenticationService.isAuthenticated.next(false);
    await this.clearCache.clearCacheForFile('index.html');
    document.location.href = 'index.html';
  }

  async processPushNotifications() {
    // Request permission to use push notifications
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === APPCONSTANTS.GRANTED) {
        PushNotifications.register();
      } else {
      }
    });

    // Listen for native notification dismissals (Android)
    if (Capacitor.getPlatform() === 'android') {
      this.setupNativeDismissalListener();
    }

    // Handle registration errors
    PushNotifications.addListener('registrationError', (error: any) => {

    });

    // Handle successful registration
    PushNotifications.addListener('registration', (token: Token) => {

      // Send token to your server here
    });

    // Enhanced push notification handling
    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {

        const storedNotification: StoredNotification = {
          id: this.generateNotificationId(),
          title: notification.data?.title || notification.title || 'No Title',
          body: notification.data?.body || notification.body || 'No Body',
          category: notification.data?.category || 'DEFAULT',
          receivedAt: new Date(),
          data: notification.data || {},
          isRead: false,
          source: 'push',
        };

        // Add to stored notifications
        await this.addNotification(storedNotification);

        // Handle Android-specific behavior
        if (Capacitor.getPlatform() === 'android') {
          await this.handleAndroidNotification(
            storedNotification,
            notification
          );
        }
      }
    );

    // Handle push notification actions (iOS)
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (action: PushActionPerformed) => {

        if (
          action.actionId === 'OPEN_LINK' &&
          action.notification.data?.outboundUrl
        ) {
          const outboundUrl = action.notification.data.outboundUrl;
          if (outboundUrl) {
            await Browser.open({ url: outboundUrl });
          }
        }
      }
    );
  }

  private async handleAndroidNotification(
    storedNotification: StoredNotification,
    originalNotification: PushNotificationSchema
  ): Promise<void> {
    try {
      // Store reference to pending notification
      this.pendingAndroidNotifications.set(
        storedNotification.id,
        storedNotification
      );

      // Create enhanced local notification for Android
      const localNotificationOptions: ScheduleOptions = {
        notifications: [
          {
            id: storedNotification.id,
            title: storedNotification.title,
            body: storedNotification.body,
            actionTypeId: storedNotification.category,
            extra: {
              ...storedNotification.data,
              originalId: storedNotification.id,
              category: storedNotification.category,
            },
            schedule: { at: new Date(Date.now() + 1000) }, // Schedule 1 second from now
            sound: 'default',
            smallIcon: 'ic_stat_icon_config_sample',
          },
        ],
      };

      // Add action buttons for specific categories
      if (
        storedNotification.category === 'OPEN_BROWSER_URL' &&
        storedNotification.data?.outboundUrl
      ) {
        localNotificationOptions.notifications[0].actionTypeId =
          'OPEN_BROWSER_URL';
        localNotificationOptions.notifications[0].extra!.outboundUrl =
          storedNotification.data.outboundUrl;
      }

      const result = await LocalNotifications.schedule(
        localNotificationOptions
      );
    } catch (error) {
    }
  }

  private generateNotificationId(): number {
    return (
      Math.floor(Math.random() * 0xffffffff) * (Math.random() < 0.5 ? -1 : 1)
    );
  }

  private async addNotification(
    notification: StoredNotification
  ): Promise<void> {
    const currentNotifications = this.notificationsSubject.value;
    const updatedNotifications = [notification, ...currentNotifications];

    // Keep only last 100 notifications to prevent memory issues
    if (updatedNotifications.length > 100) {
      updatedNotifications.splice(100);
    }

    this.notificationsSubject.next(updatedNotifications);

    // Save to persistent storage
    await this.notificationStorage.saveNotifications(updatedNotifications);
  }

  // Enhanced public methods for notification management
  getNotifications(): StoredNotification[] {
    return this.notificationsSubject.value;
  }

  async clearAllNotifications(): Promise<void> {
    this.notificationsSubject.next([]);
    await this.notificationStorage.clearNotifications();

    // Clear any pending local notifications on Android
    if (Capacitor.getPlatform() === 'android') {
      try {
        await LocalNotifications.cancel({
          notifications: Array.from(
            this.pendingAndroidNotifications.keys()
          ).map(id => ({ id })),
        });
        this.pendingAndroidNotifications.clear();
      } catch (error) {
      }
    }
  }

  async removeNotification(id: number): Promise<void> {
    const currentNotifications = this.notificationsSubject.value;
    const updatedNotifications = currentNotifications.filter(
      notif => notif.id !== id
    );

    this.notificationsSubject.next(updatedNotifications);
    await this.notificationStorage.saveNotifications(updatedNotifications);

    // Remove from pending Android notifications
    if (this.pendingAndroidNotifications.has(id)) {
      this.pendingAndroidNotifications.delete(id);
      try {
        await LocalNotifications.cancel({ notifications: [{ id }] });
      } catch (error) {
      }
    }
  }

  async markNotificationAsRead(id: number): Promise<void> {
    const currentNotifications = this.notificationsSubject.value;
    const updatedNotifications = currentNotifications.map(notif =>
      notif.id === id ? { ...notif, isRead: true } : notif
    );

    this.notificationsSubject.next(updatedNotifications);
    await this.notificationStorage.saveNotifications(updatedNotifications);
  }

  getNotificationCount(): number {
    return this.notificationsSubject.value.length;
  }

  getUnreadNotificationCount(): number {
    return this.notificationsSubject.value.filter(notif => !notif.isRead)
      .length;
  }

  // Enhanced permission checking
  private async checkPermissions(): Promise<void> {
    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'granted') {
        await PushNotifications.register();
        return;
      } else if (permStatus.receive === 'denied') {
        await this.actionPrompt(
          'Notification Permissions Denied',
          'Please check your device settings to enable notifications for this app!'
        );
        return;
      } else {
        // Request permissions
        const permissionStatus = await PushNotifications.requestPermissions();
        if (permissionStatus.receive === 'granted') {
          await PushNotifications.register();
        } else {
          await this.actionPrompt(
            'Notification Permissions Required',
            'This app needs notification permissions to keep you updated!'
          );
        }
      }

      // Also check local notification permissions
      const localPermissions = await LocalNotifications.checkPermissions();
      if (localPermissions.display !== 'granted') {
        await LocalNotifications.requestPermissions();
      }
    } catch (e) {
    }
  }

  async actionPrompt(
    header: string,
    message?: string,
    actions?: (string | AlertButton)[],
    subHeader?: string
  ) {
    const buttons = actions || ['OK'];
    const alert = await this.alertCtrl.create({
      mode: 'ios',
      header,
      subHeader,
      message,
      buttons,
    });
    await alert.present();
  }

  private addAllIcons() {
    addIcons({
      notifications,
      information,
      informationOutline,
      informationCircle,
      close,
      card,
      doc,
      cash,
      listCircle,
      cloudUpload,
      folder,
      arrowForward,
      contrastSharp,
      chatbubble,
      checkmarkCircle,
      locationSharp,
      cashOutline,
      cashSharp,
      time,
      help,
      informationCircleOutline,
      timeOutline,
      timerOutline,
      timer,
      call,
      arrowDownCircle,
      lockClosed,
      desktop,
      mail,
      mailOutline,
      phonePortraitOutline,
      closeOutline,
      chevronUpOutline,
      chevronDownOutline,
      list,
      logoAndroid,
      menu,
      flag,
      print,
      logoApple,
      add,
      contrast,
      trash,
      calendar,
      person,
      ellipsisHorizontal,
      reorderTwoOutline,
      home,
      notificationsCircleOutline,
      cropOutline,
      flash,
      refreshOutline,
      contract,
      camera,
      cameraOutline,
      open,
      chevronForwardOutline,
      chevronForwardCircle,
      mailOpen,
      ellipse,
      eyeOffOutline,
      eyeOutline,
      chevronBack,
      mailSharp,
      paperPlaneOutline,
      paperPlaneSharp,
      heartOutline,
      heartSharp,
      archiveOutline,
      archiveSharp,
      trashOutline,
      trashSharp,
      warningOutline,
      warningSharp,
      bookmarkOutline,
      bookmarkSharp,
      alertCircle,
      'hand-shake': 'assets/icon/handshake-solid.svg',
      'layer-group': 'assets/icon/layer-group-solid.svg',
      'bell-solid': 'assets/icon/bell-solid.svg',
      'bell-orange': 'assets/icon/bell-orange.svg',
      'money-solid': 'assets/icon/money-solid.svg',
      'clock-full': 'assets/icon/clock-full.svg',
      'upload-solid': 'assets/icon/upload-solid.svg',
      'id-card-solid': 'assets/icon/id-card-solid.svg',
      'file-circle-question-solid':
        'assets/icon/file-circle-question-solid.svg',
      'rectangle-list-solid': 'assets/icon/rectangle-list-solid.svg',
      'list-check-solid': 'assets/icon/list-check-solid.svg',
      'circle-question-solid': 'assets/icon/circle-question-solid.svg',
      'list-check': 'assets/icon/list-check-solid.svg',
      'faq-solid': 'assets/icon/faq-solid.svg',
      'helpful-solid': 'assets/icon/helpful-solid.svg',
      'technical-solid': 'assets/icon/technical-solid.svg',
      'license-status-solid': 'assets/icon/license-status-solid.svg',
      'license-release-solid': 'assets/icon/license-release-solid.svg',
    });
  }

  private setupNativeDismissalListener() {
    // Listen for broadcasts from native Android code when notifications are dismissed
    if (Capacitor.getPlatform() === 'android') {
      // This would require a Capacitor plugin to listen for Android broadcasts
      // For now, we'll rely on the Ionic-side notification management
    }
  }
}
